import { ChevronRight } from 'lucide-react';

const HERO_BG = "/images/IMG_1670.jpg";

const HeroSection = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_BG})`, backgroundPosition: '30% center' }}
      />
      
      {/* Dark Overlay - adjusted for mechanic visibility on left */}
      <div className="absolute inset-0 bg-gradient-to-l from-black/95 via-black/70 to-black/30" />
      
      {/* Content - moved to right side */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-32">
        <div className="max-w-3xl ml-auto">
          {/* Label */}
          <span 
            className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-yellow-400 mb-6 animate-fade-in"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            data-testid="hero-label"
          >
            Expertos en Mecánica Automotriz
          </span>
          
          {/* Main Heading */}
          <h1 
            className="text-5xl sm:text-6xl lg:text-7xl font-black uppercase tracking-tighter leading-none text-white mb-6 animate-fade-in-up"
            style={{ fontFamily: "'Barlow Condensed', sans-serif", animationDelay: '100ms' }}
            data-testid="hero-title"
          >
            MV Auto Expert
          </h1>
          
          {/* Subtitle */}
          <p 
            className="text-lg sm:text-xl text-zinc-300 mb-4 animate-fade-in-up"
            style={{ animationDelay: '200ms' }}
            data-testid="hero-subtitle"
          >
            Especialistas en vehículos domésticos e importados
          </p>
          
          {/* Services List */}
          <div 
            className="flex flex-wrap gap-3 mb-10 animate-fade-in-up"
            style={{ animationDelay: '300ms' }}
          >
            {['Transmisión', 'Diagnóstico', 'Frenos', 'Tune Up', 'Diesel', 'Gasolina'].map((service) => (
              <span 
                key={service}
                className="px-4 py-2 bg-zinc-900/80 border border-zinc-700 text-zinc-300 text-sm uppercase tracking-wider"
                data-testid={`hero-service-${service.toLowerCase()}`}
              >
                {service}
              </span>
            ))}
          </div>
          
          {/* CTA Buttons */}
          <div 
            className="flex flex-col sm:flex-row gap-4 animate-fade-in-up"
            style={{ animationDelay: '400ms' }}
          >
            <button
              onClick={() => scrollToSection('#appointments')}
              className="bg-blue-600 text-white font-bold uppercase tracking-widest px-8 py-4 hover:bg-blue-700 transition-all flex items-center justify-center gap-2 group"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
              data-testid="hero-cta-primary"
            >
              Agendar Cita
              <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => scrollToSection('#services')}
              className="bg-zinc-900/80 text-white font-bold uppercase tracking-widest px-8 py-4 border border-zinc-700 hover:border-blue-600 transition-all"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
              data-testid="hero-cta-secondary"
            >
              Ver Servicios
            </button>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-zinc-500 flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-blue-500 animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
